import { useCallback, useEffect, useState } from 'react'

import useMutationObserver from '../../../../hooks/useMutationObserver'
import { useDidMount } from '../../../../hooks/useDidMount'

export function useAppendFormScrollbarToDrawer($formContainer) {
  const didMount = useDidMount()
  // this state is used to avoid unnecessary changes on $formContainer
  const [maxDiff, setMaxDiff] = useState(0)

  const updateContainer = useCallback(() => {
    const scrollHeight = $formContainer?.scrollHeight
    const elementHeight = $formContainer?.clientHeight
    const hasScrollbar = scrollHeight > elementHeight
    const difference = scrollHeight - elementHeight + 50

    // avoid setting back the same value or setting negative value
    if (hasScrollbar && difference > maxDiff) {
      // This ensures that the vertical scrollbar will be removed from scrollbar and expand the element instead
      // This is needed to add scrollbar to the drawer level

      setMaxDiff(difference)

      $formContainer.style.paddingBottom = `${difference}px`
      $formContainer.style.marginBottom = `-${difference}px`
    }
  }, [$formContainer, maxDiff])

  const observerRef = useMutationObserver(updateContainer)

  useEffect(() => {
    const observerEl = observerRef.current
    if (didMount && observerEl && $formContainer) {
      // initialize the observer
      observerRef.current.observe($formContainer, { childList: true, attributes: true, subtree: true })
    }

    return () => {
      // remove the observer
      if (observerEl && $formContainer) {
        observerEl.disconnect()
      }
    }
  }, [didMount, observerRef, $formContainer])
}
